export default {"src":"/_next/static/media/image1.6372c864.svg","height":378,"width":570};